export default "__VITE_ASSET__DIx3f9UU__"